import { useHistory } from "react-router-dom";
import { RoutePaths } from "../../../../utils/Items";
import {
  RegistrationMode,
  RegistroIngresoNavigationState,
  RegistroIngresoPrefill,
} from "../registroIngresoNavigation";

export const useLogisticParkNavigation = () => {
  const history = useHistory();

  const navigateToRegistration = (mode: RegistrationMode, prefill?: RegistroIngresoPrefill) => {
    const state: RegistroIngresoNavigationState = {
      mode,
      intent: "append-tab",
      prefill,
    };

    history.push({
      pathname: RoutePaths.LogisticParkEntryRegistration,
      state,
    });
  };

  const navigateToManualExit = (prefill?: RegistroIngresoPrefill) => {
    navigateToRegistration("exit", prefill);
  };

  const navigateToEntry = () => {
    navigateToRegistration("entry");
  };

  return {
    navigateToRegistration,
    navigateToManualExit,
    navigateToEntry,
  };
};
